export default "__VITE_ASSET__t$PRuc_t__"